/**
 * Centralised TanStack Query keys for the POS resource. Sharing the keys here
 * keeps the sale mutation and the catalog query from drifting out of step: the
 * mutation invalidates `catalog()` so the grid refetches the stock the sale just
 * drew down.
 */
export const PosQueryKeys = {
    all: ['pos'] as const,
    catalog: () => [...PosQueryKeys.all, 'catalog'] as const,
};
